import QueryString from "query-string";
import { getState } from "../../app/StoreFactory";
import { setCookie } from "lib/cookieUtils";
import { preferencesSlice } from "redux/slices/preferencesSlice";
import { PUB_LANG, ASSET_CLASS, REGIONS } from "../../redux/slices/api/initialisePreferences";
import { postPreferences } from "./api/postPrefrences";

export const setPreference = (payload, isPost) => {
  return (dispatch) => {
    dispatch(preferencesSlice.actions.set(payload));
    savePreferenceAsCookie(payload);
    isPost && postPreferences(getState().preferences);
  };
};

export const setShallowPreference = (payload) => {
  return (dispatch) => {
    dispatch(preferencesSlice.actions.set(payload));
  };
};

export const togglePreference = (payload) => {
  return (dispatch) => {
    dispatch(preferencesSlice.actions.toggle(payload));
    savePreferenceAsCookie(payload);
  };
};

export const mergePreferences = (payload) => {
  return (dispatch) => {
    dispatch(preferencesSlice.actions.merge(payload));
    savePreferencesAsCookies();
  };
};

const savePreferenceAsCookie = ({ key }) => {
  const value = getState().preferences[key].join();
  flattenAndSetCookie(key, value);
};

const savePreferencesAsCookies = () => {
  const preferences = getState().preferences;
  Object.entries(preferences).forEach(([key, value]) => {
    flattenAndSetCookie(key, value);
  });
};

const flattenAndSetCookie = (key, value) => {
  const flattenedValue = Array.isArray(value) ? value.join() : value;
  setCookie(key, flattenedValue);
};

export const prefsToSearchUrl = (preferences, search) => {
  let qs = QueryString.parse(search);
  qs["Asset Class"] = preferences[ASSET_CLASS];
  qs["Regions"] = preferences[REGIONS];
  qs["Language"] = preferences[PUB_LANG];

  return {
    pathname: `/search`,
    search: QueryString.stringify(qs),
  };
};

export const prefsToAdvancedSearchUrl = (preferences, search) => {
  let qs = QueryString.parse(search);
  qs["Asset Class"] = preferences[ASSET_CLASS];
  qs["Regions"] = preferences[REGIONS];
  qs["Language"] = preferences[PUB_LANG];

  return {
    pathname: `/advanced-search`,
    search: QueryString.stringify(qs),
  };
};

export const postPreferencesAction = (payload) => {
  return (dispatch) => {
    postPreferences(payload);
  };
};
